/** @internal */
export class _ImportHelper {
    /** @internal */
    public static _IsPickingAvailable = false;
}
